






















































import { defineComponent, onBeforeUnmount, ref } from "@vue/composition-api";
import { AgeVerificationStatus } from "@scrile/api-provider/dist/api/AgeVerificationProvider";
import { YotiAgeVerificationType } from "@scrile/api-provider/dist/api/YotiAgeVerificationProvider";
import providers from "@/lib/api";
import { $t } from "@/lib/i18nHelpers";
import { ListFields, QuickTip } from "@/types";
import BaseIcon from "@/components/Base/BaseIcon";
import BaseButton from "@/components/BaseButton";
import BaseInputRadio from "@/components/BaseInputRadio";
import ModalView from "@/components/ModalView";
import QuickTipsItem from "@/components/QuickTipsItem";

export default defineComponent({
  name: "AgeVerificationSetup",
  components: { BaseButton, BaseIcon, BaseInputRadio, QuickTipsItem, ModalView },
  props: {
    processing: { type: Boolean, default: false },
  },
  setup(_, { emit }) {
    const type = ref<YotiAgeVerificationType | null>(null);
    const loading = ref(false);
    const yotiUrl = ref("");

    const quickTip: QuickTip = {
      icon: "msr-info",
      text: $t("You must be 18+ to access restricted content."),
    };

    const option: ListFields = [
      { value: YotiAgeVerificationType.FACIAL, text: $t("Face recognition"), icon: "msr-face" },
      { value: YotiAgeVerificationType.CREDIT_CARD, text: $t("Credit card check"), icon: "msr-credit_card" },
    ];

    const onSubmit = async () => {
      if (!type.value) return;
      try {
        loading.value = true;
        yotiUrl.value = await providers.YotiAgeVerificationProvider.start({
          data: {
            type: type.value,
            successUrl: new URL("/yoti/age-verification/success.html", location.origin).toString(),
            cancelUrl: new URL("/yoti/age-verification/cancel.html", location.origin).toString(),
          },
        });
        emit("update:status", AgeVerificationStatus.PENDING);
      } finally {
        loading.value = false;
      }
    };

    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-expect-error
    window.YotiAgeVerificationCallback = {
      onCancel: () => emit("reset"),
      onFinish: () => emit("finish"),
    };

    onBeforeUnmount(() => {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-expect-error
      delete window.YotiAgeVerificationCallback;
    });

    return {
      quickTip,
      option,
      type,
      loading,
      yotiUrl,
      onSubmit,
    };
  },
});
